import React, { useEffect, useState } from "react";
// import "./style.scss";
import useApiPost from "../../Hooks/usePost";
import { useNavigate } from "react-router-dom";
import Storelist from "../../Store/Actions";
import { Logo } from "../../appconfig";
import { toast } from "react-toastify";
import { setLoader } from "../../Store/Actions/page";
import { BASE_URL_API, BASE_URL_API2 } from "../../appconfig";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const ForgotPassword = () => {
  const { setLoading } = Storelist();
  const forgotPasswordAPI = useApiPost();
  const Navigate = useNavigate();

  const FormSubmitHandler = (e) => {
    e.preventDefault();
    let data = new FormData(e.target);
    setLoading(true);
    forgotPasswordAPI.Postdata(`${BASE_URL_API()}forgotpassword`, false, {
      emailId: data.get("email"),
    });
  };

  useEffect(() => {
    if (forgotPasswordAPI?.data !== null) {
      if (forgotPasswordAPI.data?.status === 200) {
        toast.success("Email sent successfully", {
          position: "top-center",
          onClose: () => Navigate(-1, { replace: true }),
        });
      }
      setLoading(false);
    } else if (forgotPasswordAPI.error !== null) {
      toast.error("Something went wrong", {
        position: "top-center",
      });
      setLoading(false);
    }
    forgotPasswordAPI.setData(null);
    forgotPasswordAPI.setError(null);
  }, [forgotPasswordAPI?.data, forgotPasswordAPI?.error]);

  return (
    <div className="login-container">
      <div className="login-input-wrapper">
        <div className="login-header">
          <img src={Logo} alt="Logo" />
          <button className="invisible">
            <i className="fa-solid fa-location-dot"></i>
            <span>Velachery</span>
          </button>
        </div>

        <form action="" onSubmit={FormSubmitHandler} className="relative">
          <input
            type="email"
            name="email"
            id="email"
            placeholder="Please enter your email"
            required
          />
          <div className="btn-container justify-center">
            <button type="submit">send Link</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ForgotPassword;
